export const TIME_DEFAULT = '300ms';
export const TIME_MOBILE = '400ms';

export const EASE_DEFAULT = 'ease';
export const EASE_MOBILE = EASE_DEFAULT;

export const DEFAULT = `${TIME_DEFAULT} ${EASE_DEFAULT}`;
export const DEFAULT_MOBILE = `${TIME_MOBILE} ${EASE_MOBILE}`;
